<template>
  <a-form
    id="my_form_styl"
    :label-col="{
      span: 12,
    }"
    :wrapper-col="{
      span: 12,
    }"
    v-if="true"
    :form="form"
  >
    <a-form-item :label="$t('Status')">
      <h3 style="font-weight: bold">
        <a-tag color="#FCB76F">{{ $t(document.status) }}</a-tag>
      </h3>
    </a-form-item>

    <a-form-item :label="$t('File name')">
      <a-tooltip>
        <template slot="title">
          <span>{{ document.NAME }}</span>
        </template>
        <span>{{ document.NAME }}</span>
      </a-tooltip>
    </a-form-item>

    <a-form-item :label="$t('Document type')">
      <span v-if="currentEdit">
        <span v-if="flagDoctype" @click="flagDoctype = !flagDoctype">
          {{ $t(document.document_type) }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <a-select
          @change="changePromptStatus"
          v-else
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'document_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document type') + $t('required_field'),
                },
              ],
              initialValue: $t(document.document_type),
            },
          ]"
        >
          <!-- <a-select-option value="Regular document">{{ $t('Regular document') }}</a-select-option>
          <a-select-option value="Сonfidential document">{{ $t('Сonfidential document') }}</a-select-option>
          <a-select-option value="Invoice">{{ $t('Invoice') }}</a-select-option>-->

          <a-select-option value="Dokument zwykly">{{
            $t("Regular document")
          }}</a-select-option>
          <a-select-option value="Dokument poufny">{{
            $t("Сonfidential document")
          }}</a-select-option>
          <a-select-option value="FVZ">{{ $t("Invoice") }}</a-select-option>
        </a-select>
      </span>
      <span v-else>{{ $t(document.document_type) }}</span>
    </a-form-item>

    <a-form-item :label="$t('Document name')">
      <span v-if="currentEdit">
        <span
          v-if="flagDocName"
          @click="flagDocName = !flagDocName"
          style="display: flex; cursor: pointer"
        >
          {{ document.title }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>

        <a-input
          @change="changePromptStatus"
          v-else
          v-decorator="[
            'title',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document name') + $t('required_field'),
                },
              ],
              initialValue: document.title,
            },
          ]"
        />
      </span>
      <div v-else style="white-space: nowrap; overflow: hidden">
        {{ document.title }}
      </div>
    </a-form-item>

    <a-form-item :label="$t('Date of receiving')">
      <span v-if="currentEdit">
        <a-date-picker
          @change="changePromptStatus"
          :disabled="disableFromResponsible || !currentEdit"
          v-decorator="[
            'date_send',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of receiving') + $t('required_field'),
                },
              ],
              initialValue:
                document.date_send != undefined && document.date_send != ''
                  ? moment(document.date_send, 'YYYY-MM-DD')
                  : '',
            },
          ]"
        />
      </span>
      <span v-else>{{ document.date_send }}</span>
    </a-form-item>

    <a-form-item :label="$t('Date of issue')">
      <a-date-picker
        @change="changePromptStatus"
        :disabled="!currentEdit"
        :format="YYYY - MM - DD"
        v-decorator="[
          'date_recept',
          {
            rules: [
              {
                required: false,
                message: $t('Date of issue') + $t('required_field'),
              },
            ],
            initialValue:
              document.date_recept != ''
                ? moment(document.date_recept, 'YYYY-MM-DD')
                : '',
          },
        ]"
      />
    </a-form-item>

    <a-form-item :label="$t('Document number')">
      <a-input
        style="width: 100%"
        @change="changePromptStatus"
        :disabled="!currentEdit"
        v-decorator="[
          'num_doc',
          {
            rules: [
              {
                required: false,
                message: $t('Document number') + $t('required_field'),
              },
            ],
            initialValue: document.num_doc,
          },
        ]"
      />
    </a-form-item>

    <a-form-item :label="$t('main_company_n_hub')">
      <span v-if="currentEdit">
        <span v-if="flagMyCompany" @click="flagMyCompany = !flagMyCompany">
          {{ my_company }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <div v-else>
          <a-input 
            @change="changePromptStatus"
            @click="handleChangeMyCompany()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="myCompanyTitle"
            />
         <!-- <a-select
            @change="handleMyCompanyChange"
            showSearch
            optionFilterProp="children"
            v-decorator="[
              'my_company',
              {
                rules: [
                  {
                    required: true,
                    message: $t('main_company_n_hub') + $t('required_field'),
                  },
                ],
                initialValue: document.my_company,
              },
            ]"
          >
            <a-select-option v-for="comp in info.my_company" :key="comp.ID">
             
              {{ comp.TITLE }} /
              {{
                Array.isArray(comp[user_setup.nip_field])
                  ? comp[user_setup.nip_field][0]
                  : typeof comp[user_setup.nip_field] == "string"
                  ? comp[user_setup.nip_field]
                  : ""
              }}
            </a-select-option>
          </a-select>-->
        </div>
      </span>
      <span v-else>{{ my_company }}</span>
    </a-form-item>

    <!-- <a-form-item :label="$t('MPK')">
      <a-select
        :disabled="!currentEdit"
        v-decorator="[
          'mpk',
          { rules: [{ required: true, message: $t('MPK')+ $t('required_field') }], initialValue: mpkPool[0] },
        ]"
      >
        <a-select-option v-for="i in mpkPool" :key="i">{{ i }}</a-select-option>
      </a-select>
    </a-form-item>-->

    <a-form-item :label="$t('Owner')">
      <span>{{ companyAssis }}</span>
    </a-form-item>

    <a-form-item :label="$t('Contractor')">
      <span v-if="currentEdit">
        <span v-if="flagKontr" @click="flagKontr = !flagKontr">
          {{ company }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
         <a-input 
            v-else
            @change="changePromptStatus"
            @click="handleChangeContractor()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="contactorTitle"
          />
        <!--<a-select
          v-else
          showSearch
          optionFilterProp="children"
          @change="changePromptStatus"
          @dropdownVisibleChange="companyUpdate"
          style="width: 85%"
          v-decorator="[
            'kontragent',
            {
              rules: [
                {
                  required: true,
                  message: $t('Contractor') + $t('required_field'),
                },
              ],
              initialValue: document.kontragent,
            },
          ]"
        >
          <a-select-option v-for="comp in info.company" :key="comp.ID">
            {{ comp.TITLE }} /
            {{
              Array.isArray(comp[user_setup.nip_field])
                ? comp[user_setup.nip_field][0]
                : typeof comp[user_setup.nip_field] == "string"
                ? comp[user_setup.nip_field]
                : ""
            }}
          </a-select-option>
        </a-select>-->
      </span>
      <span v-else>{{ company }}</span>
      <a
        v-show="info.nip"
        :href="`https://${domain}/marketplace/app/${info.nip}/`"
        target="_blank"
        style="padding-left: 5px"
      >
        <a-icon type="plus-circle" />
      </a>
    </a-form-item>

    <a-form-item :label="$t('Specialization')">
      <a-select
        @change="changePromptStatus"
        showSearch
        mode="tags"
        :disabled="!currentEdit"
        optionFilterProp="children"
        v-decorator="[
          'SPECJALIZACJA',
          {
            rules: [
              {
                required: false,
              },
            ],
            initialValue: specializationInitialValue,
          },
        ]"
      >
        <a-select-option v-for="i in specialization" :key="i">{{
          i
        }}</a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item :label="$t('Tag')">
      <a-select
        @change="changePromptStatus"
        :dropdownMatchSelectWidth="false"
        mode="tags"
        :disabled="!currentEdit"
        v-decorator="[
          'Teczka',
          { rules: [{ required: false }], initialValue: TeczkaUser },
        ]"
      >
        <a-select-option v-for="i in teczkalist" :key="i">{{
          i
        }}</a-select-option>
      </a-select>
      <div>
        <a-tag color="blue" v-for="i of other_tags" :key="i">{{
          i.tagData
        }}</a-tag>
      </div>
    </a-form-item>

    <a-form-item :label="$t('Keywords')">
      <a-select
        @change="changePromptStatus"
        mode="multiple"
        :disabled="!currentEdit"
        v-decorator="[
          'tags',
          { rules: [{ required: false }], initialValue: doc_tags },
        ]"
      >
        <a-select-option v-for="i in key_words" :key="i">{{
          i
        }}</a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item :label="$t('Original')">
      <span v-if="document.status == 'OPISANY' || !currentEdit">{{
        document.arch_doc_type
      }}</span>
      <span v-else>
        <span
          v-if="flagAcrhType && document.status == 'ZARCHIWIZOWANY'"
          @click="flagAcrhType = !flagAcrhType"
        >
          {{ document.arch_doc_type }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>

        <a-select
          v-else
          @change="changePromptStatus"
          default-value="1"
          v-decorator="[
            'arch_doc_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Original') + $t('required_field'),
                },
              ],
              initialValue: document.arch_doc_type,
            },
          ]"
        >
          <a-select-option value="Electronic">{{
            $t("Electronic")
          }}</a-select-option>
          <a-select-option value="Paper">{{ $t("Paper") }}</a-select-option>
        </a-select>
      </span>
    </a-form-item>
    <!-- <a-modal
      v-model="showFormValidationErrorModal"
      @ok="showFormValidationErrorModal = false; ignoreErrorsAndSubmit()"
      @cancel="showFormValidationErrorModal = false;"
      :okText="$t('Save')"
      :cancelText="$t('Close without saving')"
      centered
    >
      <p>{{ $t('fields are successfully filled') }}</p>
      <p>{{ $t('what_to_do') }}</p>
    </a-modal>-->
    <a-modal
      v-model="showFormValidationErrorModal"
      @ok="
        showFormValidationErrorModal = false;
        ignoreErrorsAndSubmit();
      "
      @afterClose="showFormValidationErrorModal = true"
      :okText="$t('SaveModal')"
      :cancelText="$t('No modal')"
      :cancelButtonProps="{
        props: {
          display: 'none',
        },
      }"
      centered
    >
      <p>{{ $t("fields are successfully filled") }}</p>
    </a-modal>
    <!-- 
    <a-modal
      v-model="showFormValidationErrorModalForFail"
      @ok="showFormValidationErrorModalForFail = false;"
      @cancel="showFormValidationErrorModalForFail = false; onback()"
      :okText="$t('Back to editing')"
      :cancelText="$t('Close without saving')"
      centered
    >
      <p>{{ $t('mandatory_fields_r_unfilled') }}</p>
      <p>{{ $t('what_to_do') }}</p>
    </a-modal>-->
    <a-modal
      v-model="showFormValidationErrorModalForFail"
      @ok="
        showFormValidationErrorModalForFail = false;
        ignoreErrorsAndSubmit();
      "
      @afterClose="showFormValidationErrorModalForFail = true"
      @cancel="
        showFormValidationErrorModalForFail = false;
        onback();
      "
      :okText="$t('SaveModal')"
      :cancelText="$t('Close without saving')"
      centered
    >
      <p>{{ $t("mandatory_fields_r_unfilled") }}</p>
      <p>{{ $t("what_to_do") }}</p>
    </a-modal>
  </a-form>
</template>
<script>
import moment from "moment";
import { requestStep, getLangToSaveStage2 } from "../requestFunc";

export default {
  props: [
    "document",
    "info",
    "user_setup",
    "key_words",
    "specialization",
    "responsible",
    "profile",
    "commentsData",
    "currentEdit",
    "isPromptAvailableParent",
  ],
  data() {
    return {
      form: this.$form.createForm(this, { name: "second_set" }),
      // nip_field_for_company: "",
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },

      user_tags: [],
      other_tags: [],
      doc_tags:
        this.document.key_words != undefined
          ? JSON.parse(this.document.key_words)
          : [],

      teczkalist: [],
      contractor: '',
      myCompany: '',
      contactorTitle: '',
      myCompanyTitle: '',
      flagMyCompany: true,
      flagReceiving: true,
      flagComment: true,
      flagDoctype: true,
      flagDocName: true,
      flagKontr: true,

      showFormValidationErrorModal: false,
      showFormValidationErrorModalForFail: false,

      mpkPool: [],
    };
  },
  computed: {
    specializationInitialValue() {
      let spec = this.document.SPECJALIZACJA;
      if (spec) {
        try {
          spec = JSON.parse(spec);
          if (typeof spec == "string") throw Error;
          if (spec != null) {
            spec = [spec];
          } else spec = [];
        } catch {
          if (spec != null) {
            spec = [spec];
          } else spec = [];
          return spec;
        }
        return spec;
      }
      return [];
    },
    // геттер вычисляемого значения
    my_company() {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      ) ?? { TITLE: "" };
      return comp.TITLE;
    },
    company() {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.kontragent
      ) ?? { TITLE: "" };
      return comp.TITLE;
    },
    companyAssis() {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      ) ?? { ASSIGNED_BY_ID: -1 };
      let user = this.info.data_user.find(
        (x) => x.ID == comp.ASSIGNED_BY_ID
      ) ?? {
        NAME: "",
        LAST_NAME: "",
      };
      return user.NAME + " " + user.LAST_NAME;
    },

    TeczkaUser() {
      let mas = [];
      for (let i of this.user_tags) {
        mas.push(i.tagData);
      }
      return mas;
    },
  },
  methods: {
    moment,
    changePromptStatus() {
      if (!this.isPromptAvailableParent) {
        this.isPromptAvailableParent = true;
        this.$emit("changePromptStatus", this.isPromptAvailableParent);
      }
    },
    handleChangeMyCompany() {
    // eslint-disable-next-line
      BX24.selectCRM({
            entityType: ['company'],
            multiple: false
          }, (info) => {
            console.log(info, 'info');
            this.myCompany = info.company[0].id.split('_')[1];
            this.myCompanyTitle = info.company[0].title;
            console.log(this.myCompany, 'this.myCompany');
            console.log(this.myCompanyTitle, 'this.myCompanyTitle');
      })
    },
    handleChangeContractor() {
    // eslint-disable-next-line
      BX24.selectCRM({
            entityType: ['company'],
            multiple: false
          }, (info) => {
            console.log(info, 'info');
            this.contractor = info.company[0].id.split('_')[1];
            this.contactorTitle = info.company[0].title;
            console.log(this.contractor, 'this.myCompany');
            console.log(this.contactorTitle, 'this.myCompanyTitle');
      })
    },
    mpkPoolFetch() {
      try {
        this.mpkPool = this.info.my_company.find(
          (x) => x.ID == this.document.my_company
        ).UF_CRM_MPK_LIST;
      } catch {
        this.mpkPool = [];
      }
    },
    companyUpdate(open) {
      let vm = this;
      if (open) {
        // eslint-disable-next-line
        BX24.callMethod(
          "crm.company.list",
          {
            filter: {
              ">ID": vm.info.company[vm.info.company.length - 1].ID,
            },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              let res = result.data();
              vm.info.company = vm.info.company.concat(res);

              if (result.more()) result.next();
              else {
                vm.info.company = vm.info.company.filter(
                  (el, i) =>
                    vm.info.company.findIndex((x) => x.ID == el.ID) == i
                );
              }
            }
          }
        );
      }
    },
    handleMyCompanyChange(val) {
      this.changePromptStatus();
      this.document.my_company = val;
      this.mpkPoolFetch();
      console;
      this.form.setFieldsValue({ mpk: this.mpkPool[0] });
    },
    ignoreErrorsAndSubmit(comments = this.comments) {
      this.form.validateFields((err, values) => {
        if (err) {
          this.changeSpinning();
          requestStep(this.saveValues(values, comments))
            .done((data) => {
              console.log(data);
              var res = JSON.parse(data);
              this.document.status = res.status;
              this.document.title =
                values.title != undefined ? values.title : this.document.title;
              if (res.name) {
                this.document.NAME = res.name;
              }
              this.changeSpinning();
              if (res.status == "ZARCHIWIZOWANY") {
                this.onback(this.document.ID);
              } else {
                this.onback(this.document.ID, true);
              }
              this.$message.success(this.$t("Document Description Saved"));
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("Error describing document"));
              this.changeSpinning();
              this.onback();
            })
            .always(() => {});
          // return;
        } else {
          this.changeSpinning();
          requestStep(this.saveValues(values, comments))
            .done((data) => {
              var res = JSON.parse(data);
              this.document.status = res.status;
              this.document.title =
                values.title != undefined ? values.title : this.document.title;
              if (res.name) {
                this.document.NAME = res.name;
              }
              this.changeSpinning();
              if (res.status == "ZARCHIWIZOWANY") {
                this.onback(this.document.ID);
              } else {
                this.onback(this.document.ID, true);
              }
              this.$message.success(this.$t("Document Description Saved"));
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("Error describing document"));
              this.changeSpinning();
              this.onback();
            })
            .always(() => {});
        }
      });
    },
    submit(comments) {
      this.form.validateFields((err) => {
        if (err) {
          this.showFormValidationErrorModalForFail = true;
        } else {
          this.showFormValidationErrorModal = true;
        }
      });
      this.comments = comments;
    },
    saveValues(values, comments) {
      values.date_recept =
        values.date_recept != ""
          ? moment(values.date_recept).format("YYYY-MM-DD")
          : "";

      if (
        values.date_send != undefined &&
        values.date_send != "" &&
        values.date_send != "Invalid date"
      ) {
        values.date_send = moment(values.date_send).format("YYYY-MM-DD");
      } else {
        values.date_send = "";
      }

      let lang = getLangToSaveStage2();
      console.log(lang);

      let data = {
        run: "savedocumentstage2",
        title: this.document.title != undefined ? this.document.title : "",
        date_send: values.date_send,
        date_recept: values.date_recept,
        num_doc: values.num_doc,
        // mpk: values.mpk,
        comments: comments,
        SPECJALIZACJA: values.SPECJALIZACJA,
        ID: this.document.ID,
        name: this.document.NAME,
        document_type: this.document.document_type,
        url: this.document.url,
        proj_assist: this.responsible,
        elemid: this.document.mainid,
        arch_doc_type: values.arch_doc_type,
        lang: lang,
      };
      console.log(this.myCompany, 'this.myCompany');
      if (this.myCompany) {
        console.log(this.myCompany, 'this.myCompany23');
        data.my_company = this.myCompany;
      } else {
        data.my_company = this.document.my_company;
      }
      if (this.contractor) {
        data.kontragent = this.contractor;
      } else {
        data.kontragent = this.document.kontragent;
      }
      for (let key in values) {
        if (
          values[key] != this.document[key] &&
          typeof values[key] == typeof this.document[key]
        ) {
          data[key] = {
            old: this.document[key],
            new: values[key],
          };
        }
      }

      let def_tags = JSON.stringify(this.doc_tags);
      let set_tags = JSON.stringify(values.tags);
      if (def_tags != set_tags) {
        data.key_words = { old: this.doc_tags, new: values.tags };
        this.document.key_words = set_tags;
      }
      var kk = [];
      for (var i of values.Teczka) {
        kk.push({ id: this.profile["ID"], tagData: i });
      }
      data.Teczka = JSON.stringify(this.other_tags.concat(kk));

      // this.document.mpk = values.mpk;
      this.document.num_doc = values.num_doc;
      this.document.Teczka = data.Teczka;
      this.document.date_recept = values.date_recept;
      this.document.SPECJALIZACJA = JSON.stringify(values.SPECJALIZACJA);

      return data;
    },
    onback(idFile, unshift) {
      this.$emit("onback", {
        visible_doc: true,
        unshift_elem: unshift,
        remove_elem: idFile,
      });
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    // eslint-disable-next-line
    let auth = BX24.getAuth();
    this.domain = auth.domain;

    // console.log("user fields");
    // this.nip_field_for_company = this.info.userfields.filter(elem => {
    //   if (elem.title == this.user_setup.nip_field) {
    //     return elem;
    //   }
    // })[0].listLabel;

    // console.log(this.nip_field_for_company);

    this.other_tags = [];
    this.user_tags = [];
    let tags = JSON.parse(this.document.Teczka);
    var listtags = this.info.teczkalist;
    for (let item of tags) {
      if (item.id != this.profile["ID"]) {
        this.other_tags.push(item);
        let index = listtags.findIndex((x) => x == item.tagData);
        if (index != -1) {
          listtags.splice(index, 1);
        }
      } else {
        this.user_tags.push(item);
      }
    }
    this.teczkalist = listtags;

    this.mpkPoolFetch();
    // eslint-disable-next-line
    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>